import React, { useEffect } from "react";
import { List, ListItem, ListItemText, Divider } from "@material-ui/core";
import "../styles/AdminSideNav.css";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../actions/user.actions";
import { useHistory } from "react-router-dom";

function AdminSideNav() {
  const LoginReducer = useSelector((state) => state.LoginReducer);
  const dispatch = useDispatch();
  const history = useHistory();

  const checkedRole = "superAdmin";


  useEffect(() => {
    if (!LoginReducer.loggedIn) {
      history.push("/login");
    }
  }, [LoginReducer, history]);

  function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
  }

  const handleLogOut = () => {
    dispatch(userActions.logout());
  };

  return (
    <div className="sidenav">
      {LoginReducer.loggedIn && (
        <List component="nav" style={{ position: "relative", top: "40px" }}>
          <ListItemLink className="listNav" href="/admin/dashboard" button>
            <ListItemText primary="Dashboard" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/admin/NoticePage" button>
            <ListItemText primary="Notices" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/admin/applications" button>
            <ListItemText primary="New Applicants" />
          </ListItemLink>

          {LoginReducer.user.role === checkedRole && (

            <ListItemLink className="listNav" href="/admin/members" button>
              <ListItemText primary="NMO Members" />
            </ListItemLink>
          )}

          {LoginReducer.user.role ===  checkedRole && (
            <>
            <ListItemLink
              className="listNav"
              href="/admin/couple/members"
              button
            >
              <ListItemText primary="Couple Members" />
            </ListItemLink>

          <ListItemLink
            className="listNav"
            href="/admin/senior_applications"
            button
          >
            <ListItemText primary="Update Requests" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/admin/add_member" button>
            <ListItemText primary="Add New Member" />
          </ListItemLink>
            </>
          )}

          {LoginReducer.user.role === checkedRole && (

            <ListItemLink className="listNav" href="/admin/transactions" button>
              <ListItemText primary="Online Transactions" />
            </ListItemLink>
          )}
          <ListItemLink className="listNav" href="/admin/reset_password" button>
            <ListItemText primary="Reset Password" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/admin/MemberKit" button>
            <ListItemText primary="Member Kit" />
          </ListItemLink>

          {LoginReducer.user.role === checkedRole && (

            <ListItemLink
              className="listNav"
              href="/admin/set_email_pass"
              button
            >
              <ListItemText primary="Set Email Password" />
            </ListItemLink>
          )}
          <ListItemLink onClick={handleLogOut} button>
            <ListItemText primary="Log Out" />
          </ListItemLink>
        </List>
      )}
    </div>
  );
}

export default AdminSideNav;
